import CustomButton from "components/CustomButton/CustomButton";
import { Row } from "components/styles";
import ClearIcon from "icons/ClearIcon";
import SearchIcon from "icons/SearchIcon";


export const PROPS_CUSTOM_BUTTON = {
    width: "100px",
    size: "medium"
};

const FilterButtons = ({
    filters,
    applyFilters
}) => {
    const filtersFieldsIsCleared = filters.isCleared();
    return (
        <Row>
            <CustomButton
                {...PROPS_CUSTOM_BUTTON}
                icon={<SearchIcon/>}
                text="Aplicar"
                onClick={applyFilters}/>
            <CustomButton 
                {...PROPS_CUSTOM_BUTTON}
                disabled= {filtersFieldsIsCleared}
                variant={filtersFieldsIsCleared ? "primary" : "secondary"}
                icon={<ClearIcon/>}
                text="Limpiar"
                onClick={() => {
                    filters.clear();
                    applyFilters();
                }}/>
        </Row>
    );
}

export default FilterButtons;